export default "__VITE_ASSET__6e2d66fb__"